var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "ui large negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Error at line " + _vm._s(_vm.lineNumber) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('pre', {
    attrs: {
      "id": "ace-editor"
    }
  }, [_vm._v(_vm._s(_vm.code))]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui buttons",
    attrs: {
      "id": "buttons"
    }
  }, [_c('button', {
    staticClass: "ui green button",
    attrs: {
      "id": "run-btn"
    }
  }, [_vm._v("Run")]), _vm._v(" "), _c('div', {
    staticClass: "or"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui blue button",
    attrs: {
      "id": "debug-btn"
    }
  }, [_vm._v("Debug")]), _vm._v(" "), _c('div', {
    staticClass: "or"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui grey button",
    attrs: {
      "id": "reset-btn"
    }
  }, [_vm._v("Reset")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e0ba41e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 106
// module chunks = 1